import { ReactElement } from "react";

type Props = {
  text: ReactElement<"span">;
  size: "large" | "medium" | "small";
  className?: string | null;
};
export const Pill = ({ text, size, className }: Props) => {
  const styles = {
    large: "py-5 px-7 title-sm lg:title-lg",
    medium: "py-4 px-5 text-body-md lg:text-body-lg",
    small: "py-3 px-6 text-body-md",
  };
  return (
    <div
      className={`${styles[size]} bg-green-10 border-2 border-green-30 rounded-[50px] text-center text-green-dark ${className || ""}`}
    >
      {text}
    </div>
  );
};
